import padIp from 'utils/padIp';

const statusWeight = {
    down: 5,
    problem: 4,
    ok: 3,
    known_problem: 2,
    disabled: 1,
    unknown: 0
};

export default (a, b) => {
    const
        aStatus = statusWeight[a.status] || 0,
        bStatus = statusWeight[b.status] || 0;

    if (aStatus !== bStatus) {
        return aStatus < bStatus ? 1 : -1;
    }

    if (a.extra['ip'] && b.extra['ip']) {
        return padIp(a.extra['ip']) < padIp(b.extra['ip']) ? -1 : 1;
    }

    if (a.extra['mbus_id'] && b.extra['mbus_id']) {
        return a.extra['mbus_id'] < b.extra['mbus_id'] ? -1 : 1;
    }

    if (a.extra['modbus_id'] && b.extra['modbus_id']) {
        return a.extra['modbus_id'] < b.extra['modbus_id'] ? -1 : 1;
    }

    if (a.extra['one_wire_id'] && b.extra['one_wire_id']) {
        return a.extra['one_wire_id'] < b.extra['one_wire_id'] ? -1 : 1;
    }

    return a.name < b.name ? -1 : 1;
};
